import React from 'react';
import { ComponentComponentsFormSection, Form } from '../../../types/schema';
import { AnswerState } from '../types';

export const useFilteredSections = (form: Form, answers: AnswerState) => {
  const baseSections = React.useMemo(
    () => (form.formSections || []).filter((sec) => sec?.title !== 'Gateway'),
    [form.formSections],
  );

  const shouldShowSection = React.useCallback(
    (section: ComponentComponentsFormSection | null | undefined, sectionIndex: number) => {
      if (!section) return true;

      if (!section.conditionalShowQuestion || !section.conditionalShowAnswer) return true;

      const conditionalHash = section.conditionalShowQuestion;
      const conditionalAnswer = section.conditionalShowAnswer;

      for (let i = sectionIndex - 1; i >= 0; i--) {
        const prevSection = baseSections[i];
        if (!prevSection?.questions) continue;

        const matchingQuestion = prevSection.questions.find((q) => q?.hash === conditionalHash);
        if (matchingQuestion) {
          const answerEntry = Object.values(answers).find((a) => a.hash === conditionalHash);
          if (!answerEntry?.answer) return false;

          const isBoolean = typeof answerEntry.answer === 'boolean';

          if (isBoolean) {
            return answerEntry.answer === conditionalAnswer;
          }

          return String(answerEntry.answer).includes(String(conditionalAnswer));
        }
      }

      return false;
    },
    [answers, baseSections],
  );

  const filteredSections = React.useMemo(
    () => baseSections.filter((sec, index) => shouldShowSection(sec, index)),
    [baseSections, shouldShowSection],
  );

  return { filteredSections };
};
